import { t } from '@lingui/core/macro'
import { useMemo, useState } from 'react'
import ChartInsight from '~/components/chart_insight'
import ECharts from '~/components/echarts'
import FootNote from '~/components/footnote'
import AWSS3DashboardFilters from '~/dashboard/aws_s3_dashboard_filters'
import {
  awsMonthlyS3OtherSpendQueryChartPath,
  awsMonthlyS3StorageTypeSpendQueryChartPath,
  awsS3PreviousMonthSpendChartPath,
} from '~/routes'

export default function AWSS3DashboardCharts({ organizationId: orgId }) {
  const [params, setParams] = useState({})

  // memoize URLs to prevent rerenders
  const awsS3PreviousMonthSpendChartUrl = useMemo(() => awsS3PreviousMonthSpendChartPath(orgId), [orgId])
  const awsMonthlyS3StorageTypeSpendQueryChartUrl = useMemo(
    () => awsMonthlyS3StorageTypeSpendQueryChartPath(orgId),
    [orgId],
  )
  const awsMonthlyS3OtherSpendQueryChartUrl = useMemo(() => awsMonthlyS3OtherSpendQueryChartPath(orgId), [orgId])

  return (
    <div className='card'>
      <div className='card-body'>
        <AWSS3DashboardFilters organizationId={orgId} setChartParams={setParams} />

        <div className='row gy-4'>
          <div className='col-sm-6'>
            <ChartInsight
              title={t`S3 Total Spend`}
              subtitle='Showing Past Month'
              url={awsS3PreviousMonthSpendChartUrl}
              params={params}
            />
          </div>
          <div className='col-sm-6'>
            <ECharts
              title={t`S3 Spend by Storage Type`}
              chartInfoTitle='aws_s3_spend_by_storage_type'
              url={awsMonthlyS3StorageTypeSpendQueryChartUrl}
              params={params}
              showExportButton
            />
          </div>
        </div>
        <div className='row gy-4'>
          <div className='col-sm-6'>
            <ECharts
              title={t`S3 Spend by Other Costs`}
              chartInfoTitle='aws_s3_spend_by_other_costs'
              url={awsMonthlyS3OtherSpendQueryChartUrl}
              params={params}
              showExportButton
            />
          </div>
        </div>
        <FootNote />
      </div>
    </div>
  )
}
